import { render, staticRenderFns } from "./OfficialLogin.vue?vue&type=template&id=cc3a13fc&scoped=true"
import script from "./OfficialLogin.vue?vue&type=script&lang=js"
export * from "./OfficialLogin.vue?vue&type=script&lang=js"
import style0 from "./OfficialLogin.vue?vue&type=style&index=0&id=cc3a13fc&prod&lang=less"
import style1 from "./OfficialLogin.vue?vue&type=style&index=1&id=cc3a13fc&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cc3a13fc",
  null
  
)

export default component.exports